import React from 'react';
import ProdutoService from '../services/ProdutoService';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import PedidoService from '../services/PedidoService';
import { hideProcess, showProcess } from '../utils/utils';
import iconEye from '../img/icon-eye.svg'


class Pedidos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pedidos: []
            
        }
    }

    async componentDidMount(){    
        try{
                
            await showProcess();

            const response = await PedidoService.get();
            
            localStorage.setItem("carrinho", response.data.object);

            this.setState({pedidos: response.data.object});
            

        }catch(e){
            alert(e)
        }
        
        hideProcess();
        
    }

    render() {
        return(
            <div style={{margin: '20px 5%'}}>
                <h1>Pedidos</h1>
                {this.state.pedidos.map((pedido, item) => 
                    
                    <div style={{backgroundColor: "#ffffff", marginBottom: '20px', boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 5px"}}>
                        <div style={{padding: '10px', borderBottom: '1px solid #DCDCDC', fontWeight: "bold"}}>
                            {new Date(pedido.criadoEm).getDay()} de {meses[new Date(pedido.criadoEm).getMonth() + 1]} de {new Date(pedido.criadoEm).getFullYear()} às {new Date(pedido.criadoEm).toLocaleTimeString()}
                        </div>
                        <div style={{padding: '10px'}}>
                            <table style={{width: '100%'}}>
                                <tr>
                                    <td style={{width: '70px'}}>
                                        Nº: 
                                    </td>
                                    <td>
                                        {pedido.id}
                                    </td>
                                    <td rowSpan={3} style={{width: '30px'}}>
                                        <img src={iconEye} style={{width: '30px', cursor: 'pointer'}} onClick={() => window.location.href = "/pedido/"+pedido.id} />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: '70px'}}>
                                        Status: 
                                    </td>
                                    <td>
                                        {status[pedido.status]}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Qtd Itens: 
                                    </td>
                                    <td>
                                        {pedido.itens.length}
                                    </td>
                                </tr>
                            </table>
                            
                        </div>

                    </div>
                    
                )}
            </div>
        );
        
    }


}

const meses = {
    "1": "Janeiro",
    "2": "Fevereiro",
    "3": "Março",
    "4": "Abril",
    "5": "Maio",
    "6": "Junho",
    "7": "Julho",
    "8": "Agosto",
    "9": "Setembro",
    "10": "Outubro",
    "11": "Novembro",
    "12": "Dezembro",
}

const status = {
    "A": "EM ANALISE",
    "B": "CONFIRMADO",
    "C": "REJEITADO",
    "D": "CANCELADO",
    "E": "FINALIZADO"
}

export default Pedidos;
